
import './App.css';
import Header from "./Header";
import Sidebar from "./Sidebar";
import {BrowserRouter as Router , Switch  ,Route} from "react-router-dom";
import Chat from "./Chat";
import { useState } from 'react';
import Login from './Login';
import { useStateValue } from './StateProvider';
function App() {
  
  const [{ user } ,dispatch] = useStateValue();
  return (
    <div className="App">
      <Router>
        {!user ? (
          <h1><Login/></h1>
        ): (
          <>
          <Header />
          <div className="app__body">
            <Sidebar />
    
            <Switch>
            <Route path="/room/:roomid">
                <Chat />
              </Route>
              <Route path="/">
                <h1>Welcome</h1>
              </Route>
              
            </Switch>
          </div>
          </>
        )}   

      </Router>
      
    </div>
    
    
  );
}

export default App;
